/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import { types } from 'mobx-state-tree'
import { QueryBuilder } from 'mst-gql'
import { ModelBase } from './ModelBase'
import { DailyInspirationAcfModel, DailyInspirationAcfModelType } from './DailyInspirationAcfModel'
import { DailyInspirationAcfModelSelector } from './DailyInspirationAcfModel.base'
import { RootStoreType } from './index'

/**
 * WordpressDailyInspirationBase
 * auto generated base class for the model WordpressDailyInspirationModel.
 */
export const WordpressDailyInspirationModelBase = ModelBase.named('WordpressDailyInspiration')
  .props({
    __typename: types.optional(types.literal('WordpressDailyInspiration'), 'WordpressDailyInspiration'),
    _id: types.identifier,
    acf: types.union(
      types.undefined,
      types.late(() => DailyInspirationAcfModel)
    ),
    createdAt: types.union(types.undefined, types.frozen()),
    id: types.union(types.undefined, types.number),
    updatedAt: types.union(types.undefined, types.frozen())
  })
  .views((self) => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WordpressDailyInspirationModelSelector extends QueryBuilder {
  get _id() {
    return this.__attr('_id')
  }
  get createdAt() {
    return this.__attr('createdAt')
  }
  get id() {
    return this.__attr('id')
  }
  get updatedAt() {
    return this.__attr('updatedAt')
  }
  acf(
    builder:
      | string
      | DailyInspirationAcfModelSelector
      | ((selector: DailyInspirationAcfModelSelector) => DailyInspirationAcfModelSelector)
      | undefined
  ) {
    return this.__child('acf', DailyInspirationAcfModelSelector, builder)
  }
}
export function selectFromWordpressDailyInspiration() {
  return new WordpressDailyInspirationModelSelector()
}

export const wordpressDailyInspirationModelPrimitives = selectFromWordpressDailyInspiration()._id.createdAt.updatedAt
